import React from "react";
import { Container, Typography } from "@material-ui/core";
import { Titulo } from "../Titulo";
import TablaFacturasCliente from "./facturas/TablaFacturasCliente";

export default function FacturasCliente() {
  return (
    <Container>
      <Titulo>
        <Typography variant="h4" gutterBottom>
          Mis Facturas
        </Typography>
      </Titulo>
      <TablaFacturasCliente />
    </Container>
  );
}
